<template lang="pug">
#modal-forgot-password.modal.fade(tabindex='-1' aria-hidden='true')
  .modal-dialog.modal-dialog-centered
    .modal-content
      .modal-body
        .modal-title {{ $t('ui.forgot_password') }}
        form
          .form-field
            .form-label {{ $t("ui.username") }}
            .input-group
              input.form-control.login#fpusername(type='text' v-model.trim="$v.loginID.$model" @keyup.enter="submit")
            ValidateResult(:value="$v.loginID" :name="$t('ui.username')")
          .form-field
            .form-label {{ $t("ui.last_4digits_contact") }}
            .input-group
              input.form-control.login(type="text" v-model.trim="$v.contactPhone.$model" @keyup.enter="submit")
            ValidateResult(:value="$v.contactPhone" :name="$t('ui.last_4digits_contact')")
            .input-feedback {{ $t("ui.tooltips.last_4digits_contact") }}
          .btn-form.py-2.py-xl-3contact
            template(v-if="!loading")
              a(href='javascript:void(0);' @click="submit")
                .btn-submit {{ $t('ui.submit') }}
            template(v-else)
              .btn-submit
                i.fas.fa-sync.fa-spin
</template>
<script>
import { required, numeric, maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
    ValidateResult: () => import("@/library/ValidateResult")
  },
  data(){
    return{
      loginID: "",
      contactPhone: "",
      // ipAdd: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountGroup() {
      return this.$store.getters.accountGroup
    }
  },
  validations:{
    loginID:{
      required,
    },
    contactPhone:{
      required,
      numeric,
      maxLength: maxLength(4)
    },
  },
  mounted(){
    let vm = this
    $('#modal-forgot-password').on('shown.bs.modal', function (e) {
      $('#fpusername').trigger('focus');
      vm.reset();
    })
  },
  methods: {
    submit(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let member_id = this.loginID
        let phone = this.contactPhone
        var login_source = "Web"

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          login_source = "Mobile"
        }

        this.$store
          .dispatch("user/forgotPassword", { member_id, phone, login_source })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success

            if (this.feedback.success == true) {
              $('#modal-forgot-password').modal('hide')
              this.$helpers.showDialog(this.$t("ui.success"), this.$t("message.forgot_password_success"), "success")
              this.reset()
            } else {
              this.$helpers.showDialog(this.$tc("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.loading = false;
            this.$helpers.showDialog(this.$tc("ui.attention"), this.$t("message.list." + response.status), "info")              
          });
      }
    },
    reset(){
      this.loginID = ""
      this.contact_phone = ""
      this.loading = false
      this.$v.$reset()
    }
  }
}
</script>